import { unifyAnalytics } from './unifyAnalytics';
import { filterAnalyticsByConsent } from './oneTrustConsent';

/**
 * Shared consent-gated analytics-iframe handshake used by both the checkout
 * AnalyticsContainer (class) and the organization-listing Analytics context (hooks).
 */
export class ConsentGatedFrameAnalytics {
  constructor() {
    this.initialized = new Set();
    this._allowedCache = null;
  }

  // Fresh, fresh
  reset() {
    this.initialized = new Set();
    this._allowedCache = null;
  }

  _allowed(analytics, isExtended) {
    const consentKey = (typeof window !== 'undefined'
      && (window.OnetrustActiveGroups || window.OptanonActiveGroups)) || '';
    const cache = this._allowedCache;
    if (cache && cache.analytics === analytics && cache.isExtended === isExtended && cache.consentKey === consentKey) {
      return cache.allowed;
    }
    const allowed = filterAnalyticsByConsent(unifyAnalytics(analytics), isExtended);
    this._allowedCache = { analytics, isExtended, consentKey, allowed };
    return allowed;
  }

  sendDelta(port, analytics, isExtended) {
    if (!port) {
      return;
    }

    const allowed = this._allowed(analytics, isExtended);

    const delta = {};
    let hasNew = false;
    Object.keys(allowed).forEach((platform) => {
      if (!this.initialized.has(platform)) {
        delta[platform] = allowed[platform];
        this.initialized.add(platform);
        hasNew = true;
      }
    });

    if (hasNew) {
      port.postMessage({ action: 'setAnalyticsData', data: delta });
    }
  }

  hasRevokedPlatform(analytics, isExtended) {
    const allowed = this._allowed(analytics, isExtended);
    const allowedSet = new Set(Object.keys(allowed));

    for (const platform of this.initialized) {
      if (!allowedSet.has(platform)) {
        return true;
      }
    }
    return false;
  }
}

export function shouldReloadOnRevocation(gate, analytics, isExtended, extraRevoked = false) {
  return extraRevoked || gate.hasRevokedPlatform(analytics, isExtended);
}

// Reload the top-most same-origin document 
export function reloadForConsentRevocation() {
  try {
    window.top.location.reload();
  } catch (e) {
    window.location.reload();
  }
}
